import React, { PureComponent } from 'react'
import i18n from 'i18next'
import Button from '../UniformComponents/Button'
import Input from '../components/form/Input'
import Anchor from '../UniformComponents/Anchor'
import LoginLayout from '../components/Layouts/Login'

import './login.scss'

class PasswordReset extends PureComponent {
    constructor(props) {
        super(props)
        this.validateEmail = null
        const { store } = props
        const {
            expiredResetLink,
            invalidResetLink,
            usedResetLink,
        } = store

        let error = ''

        if (expiredResetLink) {
            error = i18n.t('Passwordreset_OutOfDateException')
        } else if (invalidResetLink) {
            error = i18n.t('Passwordreset_linkinvalid')
        } else if (usedResetLink) {
            error = i18n.t('Passwordreset_hasResetException')
        }

        store.resetResetErrors()

        this.state = {
            msg: '', error,
        }
    }

    register = (name, validate) => {
        this.validateEmail = validate
    }

    unregister = () => {
        this.validateEmail = null
    }

    sendRequestNew = async (e) => {
        const { store } = this.props
        const { csrf } = store

        try {
            const response = await fetch('/api/passwordreset/email', {
                method: 'post',
                withCredentials: true,
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json; charset=UTF-8',
                }),
                body: JSON.stringify({
                    email: e.target.email.value,
                    csrf,
                }),
            })
            const { status } = response
            if (status !== 200) throw new Error(status)

            this.setState({
                msg: i18n.t('reset_password_response'),
            })
        } catch (err) {
            const { message } = err
            console.log(err)
            let error = 'Error resetting password'

            if (message === '401') {
                error = 'Unable to find user'
            }

            this.setState({
                error,
            })
        }
    }

    isValid = (email) => (
        this.validateEmail({
            value: email,
            name: 'email',
        }, true)
    )

    sendRequest = async (e) => {
        e.preventDefault()

        if (!this.isValid(e.target.email.value)) {
            return
        }

        this.sendRequestNew(e)
    }

    renderInfo = () => {
        const { msg, error } = this.state

        if (msg) {
            return (
                <div className="info-msg">
                    <div className="heading">
                        <i className="fa-solid fa-circle-exclamation" />
                        <p className="msg-type">{i18n.t('reset_password_msg_sent_email')}</p>
                    </div>
                    <p className="desc">{msg}</p>
                </div>
            )
        }
        if (error) {
            return (
                <div className="error-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_error')}</p>
                    </div>
                    <p className="desc">{error}</p>
                </div>
            )
        }
        return null
    }

    render() {
        return (
            <LoginLayout>
                <div className="pwd-wrapper">
                    <h3 className="title">{i18n.t('reset_password_title')}</h3>
                    <p className="caption">{i18n.t('reset_password_caption')}</p>
                    <form action="/passwordreset" method="get" autoComplete onSubmit={this.sendRequest}>
                        <Input
                            type="text"
                            cssClass="login-input light confirm-email-input"
                            label={i18n.t('email', 'Email')}
                            name="email"
                            id="email"
                            placeholder="Enter your email address"
                            isMandatory
                            register={this.register}
                            unregister={this.unregister}
                            emptyError={i18n.t('error_email')}
                            formatError={i18n.t('format_error_email')}
                            format={(value) => (
                                value.match(/.*@.*\..*/gi)
                            )}
                        />
                        {this.renderInfo()}
                        <Button
                            cssClass="submit-btn primary large"
                            label={i18n.t('submit', 'Submit')}
                            type="submit"
                        />
                    </form>
                    <Anchor cssClass="external-anchor" href="/login">
                        <i className="fa-sharp fa-regular fa-arrow-left" />
                        {i18n.t('back_to_login', 'Back to login')}
                    </Anchor>
                </div>
            </LoginLayout>
        )
    }
}

export default PasswordReset
